const colors = {
	X: 1,
	GENERIC: 2,
	W: 3,
	U: 4,
	B: 5,
	R: 6,
	G: 7,
};

const undefinedNum = Object.keys(colors).length + 1;

export type ColorKey = keyof typeof colors;

const isNumber = (c: string) => !Number.isNaN(Number.parseInt(c, 10));
const getOrderNumber = (c: string) => {
	const val = (
		isNumber(c) ? "GENERIC" : c.toUpperCase()
	) as keyof typeof colors;

	const num = colors[val] || undefinedNum;

	return num;
};

export const colorSort = (a: string, b: string) => {
	return getOrderNumber(a) - getOrderNumber(b);
};
